import React, { useState } from "react";

const ProductArea = ({ items, count }) => {
  const [openItemId, setOpenItemId] = useState("");

  const toggleOpen = (id) => {
    setOpenItemId(id);
    if (openItemId === id) return setOpenItemId("");
  };

  return (
    <>
      {items.map((item, index) => (
        <li
          className={`nav-item col-lg-3 ${item.IsActive !== null && item.IsActive ? "active" : ""}`}
          key={item.DisplayName}
        >
          <a className="btn d-flex" href={item.Url}>
            <img
              className="float-left"
              src={i18n.CdnHostName + item.ImageUrl+ "?width=60"}
              width="60"
              height="60"
              alt={item.DisplayName}
            />
            <span>{item.DisplayName}</span>
          </a>

          {/* {count <= 0 || item.Children <= 0 ? null : (
            <>
              <span
                className={`c-nav__toggle-icon ${
                  openItemId === item.ContentLink
                    ? "c-nav__toggle-icon--rotate"
                    : ""
                }`}
                onClick={() => toggleOpen(item.ContentLink)}
              >
                <i className="icon-chevron-right"></i>
              </span>
              <ul
                className={`c-nav__list c-nav__list--vertical ${
                  openItemId === item.ContentLink ? "c-nav__list--visible" : ""
                }`}
              >
                <ProductArea items={item.Children} count={--count} />
              </ul>
            </>
          )} */}
        </li>
      ))}
    </>
  );
};

export default ProductArea;
